<template>
    <div>
        <cookie-law theme="dark-lime">
            <div slot-scope="props">
                <p>{{ $t('cookies1') }}
                  <span class="cookiesLink">
                    <a style="color: #ffffff; text-transform: underline;" target="_blank" href="https://gdpr.eu/cookies/">{{ $t('cookies2') }}. </a>
                  </span>
                  <span>{{ $t('cookies3') }} </span> 
                  <span>
                    <router-link target="_blank" class="cookiePolicyLink" :to="'/' + 'cookiePolicy/' + $i18n.locale">{{ $t('cookiePolicy') }}?</router-link>
                  </span>
                </p>
                <button class="accept-btn" @click="props.accept"><span>{{ $t('Iagree') }}</span></button>
                <button class="learnMore-btn" @click="props.close"><span>{{ $t('Disagree') }}</span></button>
            </div>
        </cookie-law>
    </div>
</template>

<script>
  import CookieLaw from 'vue-cookie-law'

  export default {
    components: { CookieLaw }
  }
</script>

<style lang="scss" scoped>
.cookiesLink {
  color: var(--bright) !important;
  text-transform: underline;
}
.cookiesLink:hover {
  color: var(--primary) !important;
}

.Cookie {
    flex-flow: column !important;
}
.learnMore-btn {
  color: var(--primary) !important;
  text-transform: uppercase;
}
.accept-btn{
  color: var(--primary) !important;
  border: 1px solid var(--primary);
  background: none;
  text-decoration: none;
  text-transform: uppercase;
  font-weight: 500;
  letter-spacing: 2px;
  padding: 10px 20px;
  border-radius: 5px;
  transition: 0.3s;
  transition-property: background;
  margin: 0 20px;
}
.cookiePolicyLink {
   color: var(--primary) !important;
}

.accept-btn:hover{
  background: var(--primary);
  color: var(--bright) !important;
}

@media screen and (max-width: 500px){
p {
    font-size: 0.8em;
    word-wrap: break-word;
}
.accept-btn{
  padding: 5px;
  font-size: 0.8em;
}
.learnMore-btn {
  padding: 5px;
  font-size: 0.8em;
}
// .Cookie--dark-lime {
//   padding: 0.2em;
// }
}

</style>